import React from 'react';
import {List, useTranslate} from 'react-admin';
import {Box, Typography} from '@mui/material';
import {t} from '../themes/statamicTokens';
import StatamicListPage from '../components/statamic/StatamicListPage';
import MonoChip from '../components/statamic/MonoChip';

const formatDateTime = (v) => {
    if (!v) return null;
    const d = new Date(v); return Number.isNaN(d.getTime()) ? String(v) : d.toLocaleString();
};

const TextCell = ({value, muted = false}) => (
    <Typography
        sx={{
            fontSize: `${t.type.body.size}px`,
            color: muted ? t.color.text.muted : t.color.text.secondary,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        }}
    >
        {value ?? '—'}
    </Typography>
);

const ActivityListStatamicInner = () => {
    const translate = useTranslate();

    const columns = [
        {
            key: 'activity', label: translate('Notificatie type'), sortable: true, sortField: 'activity', width: 180,
            render: (r) => (
                <Typography sx={{fontSize: `${t.type.bodyStrong.size}px`, fontWeight: t.type.bodyStrong.weight, color: t.color.text.primary, whiteSpace: 'nowrap'}}>
                    {r.activity || '—'}
                </Typography>
            ),
        },
        {
            key: 'post', label: translate('Post ID'), width: 100,
            render: (r) => r.additional_value
                ? <MonoChip>{r.additional_value}</MonoChip>
                : <Typography sx={{fontSize: `${t.type.caption.size}px`, color: t.color.text.muted}}>—</Typography>,
        },
        {
            key: 'description', label: translate('Description'),
            render: (r) => (
                <Typography sx={{fontSize: `${t.type.body.size}px`, color: t.color.text.primary, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                    {r.description ?? '—'}
                </Typography>
            ),
        },
        {
            key: 'guardian', label: translate('Trigger for guardian'), width: 200,
            render: (r) => <TextCell value={r.guardian_name}/>,
        },
        {
            key: 'child', label: translate('Applicable for child'), width: 200,
            render: (r) => <TextCell value={r.child_name}/>,
        },
        {
            key: 'triggered', label: translate('Trigger date'), sortable: true, sortField: 'create_date_time', width: 170,
            render: (r) => <TextCell value={formatDateTime(r.create_date_time)}/>,
        },
    ];

    return (
        <StatamicListPage
            scoped
            title={translate('Notifications')}
            subtitle={translate('Activity events triggered across the platform')}
            columns={columns}
        />
    );
};

const ActivityListStatamic = (props) => (
    <List
        {...props}
        sort={{field: 'create_date_time', order: 'DESC'}}
        perPage={25}
        actions={false}
        pagination={false}
        component={Box}
        sx={{
            backgroundColor: t.color.page,
            '& .RaList-main': {backgroundColor: t.color.page},
        }}
    >
        <ActivityListStatamicInner/>
    </List>
);

export default ActivityListStatamic;
